import Component from '../core/Component';

export default class SearchOpener extends Component {

    constructor($element) {
        super($element)
    }

    prepare() {
        this.$target = $('[data-component="Search"]')
        const search = Component.getFromElement(this.$target)
        this.$element.on('click', (event) => {
            event.stopPropagation()
            search.open()
        })
    }
}


// WEBPACK FOOTER //
// ./components/SearchOpener.js